import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function VideoModal({ open, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    if (open) {
      window.addEventListener("keydown", onKey);
      window.__lenis?.stop();
    } else {
      window.__lenis?.start();
    }
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="hero-video-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed inset-0 z-[90] bg-black/92 backdrop-blur-md flex items-center justify-center p-4 sm:p-8"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.94, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 12 }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-testid="hero-video-modal-close"
              onClick={onClose}
              className="absolute -top-12 right-0 text-slate-300 hover:text-white transition-colors flex items-center gap-2 text-xs tracking-[0.25em] uppercase"
            >
              Close <X size={18} />
            </button>
            <video
              data-testid="hero-video-player"
              src="/videos/auraxr-film.mp4"
              poster="/videos/auraxr-film-poster.jpg"
              controls
              autoPlay
              playsInline
              className="max-h-[78vh] w-auto max-w-full rounded-xl shadow-[0_40px_120px_rgba(56,189,248,0.12)]"
            />
            <p className="mt-5 text-center font-display italic text-slate-300 text-lg">
              Same classroom. <span className="text-[#38BDF8] not-italic font-medium">A whole new way to understand.</span>
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
